import { useMemo } from "react";
import DOMPurify from "dompurify";

// Teaser HTML is model-generated, so it is sanitised before it ever reaches the DOM.
const ALLOWED_TAGS = [
  "p", "br", "strong", "em", "b", "i", "u",
  "h1", "h2", "h3", "h4", "h5", "h6",
  "ul", "ol", "li", "blockquote", "span", "div", "hr",
];

export default function TeaserReveal({ html }) {
  const clean = useMemo(
    () =>
      DOMPurify.sanitize(html || "", {
        ALLOWED_TAGS,
        ALLOWED_ATTR: [],
        FORBID_TAGS: ["style", "script", "iframe", "img", "a", "form", "input"],
      }),
    [html]
  );

  if (!clean.trim()) return null;

  return (
    <div
      className="text-left text-gray-700 leading-relaxed space-y-3
        [&_h1]:text-xl [&_h1]:font-semibold [&_h1]:text-gray-900
        [&_h2]:text-lg [&_h2]:font-semibold [&_h2]:text-gray-900
        [&_h3]:text-base [&_h3]:font-semibold [&_h3]:text-gray-900
        [&_h4]:text-base [&_h4]:font-semibold [&_h4]:text-gray-900
        [&_p]:text-gray-700 [&_p]:leading-relaxed
        [&_strong]:text-gray-900 [&_strong]:font-semibold
        [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:space-y-1
        [&_ol]:list-decimal [&_ol]:pl-5 [&_ol]:space-y-1
        [&_blockquote]:border-l-2 [&_blockquote]:border-orange-300 [&_blockquote]:pl-4 [&_blockquote]:italic
        [&_hr]:my-4 [&_hr]:border-gray-200"
      dangerouslySetInnerHTML={{ __html: clean }}
    />
  );
}
